import { AxiosError } from '@src/helpers/httpClient'
import { definitions } from '@src/types/schema'
import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  SD_FEEDBACK_EVALUATION_BY_EVALUATOR,
  SD_FEEDBACK_EVALUATION_BY_SUBJECT,
  SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT,
  SD_FEEDBACK_EVALUATION_CREATE,
  SD_FEEDBACK_EVALUATION_EVALUATE_INFO,
  SD_FEEDBACK_EVALUATION_STATS,
  SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED,
  SD_FEEDBACK_QUESTION_ALL,
  SD_FEEDBACK_RESPONSE_ALL,
  SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL,
  SD_FEEDBACK_STAFF_ASSIGN_CREATE,
  SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST,
  SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST,
} from '../constants/actionTypes'

const sdFeedbackSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const sdFeedbackResponseAllSelector = createSelector(sdFeedbackSelector, data => data[SD_FEEDBACK_RESPONSE_ALL])

export const sdFeedbackResponseAllOptionsSelector = createSelector(sdFeedbackResponseAllSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({
          label: (item.response || '') as string,
          value: item.id || -1,
        }))
      : [],
  }
})

export const sdFeedbackEvalCampaignCurrentSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_EVALUATION_CAMPAIGN_CURRENT]
)

export const sdFeedbackStaffAssignStaffListSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_STAFF_ASSIGN_STAFF_LIST]
)

export const sdFeedbackStaffAssignPrincipalListSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_STAFF_ASSIGN_PRINCIPAL_LIST]
)

export const sdFeedbackEvaluationByEvaluatorSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_EVALUATION_BY_EVALUATOR]
)

export const sdFeedbackEvaluationBySubjectSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_EVALUATION_BY_SUBJECT]
)

export const sdFeedbackEvaluationCreateSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_EVALUATION_CREATE]
)

export const sdFeedbackStaffAssignCreateSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_STAFF_ASSIGN_CREATE]
)

export const sdFeedbackStaffAssignedEvaluatorsAllSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_STAFF_ASSIGNED_EVALUATORS_ALL]
)

export const sdFeedbackQuestionAllSelector = createSelector(sdFeedbackSelector, data => data[SD_FEEDBACK_QUESTION_ALL])

export const sdFeedbackEvaluationEvaluateInfoSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_EVALUATION_EVALUATE_INFO]
)

export const sdFeedbackEvaluationStatsOpenEndedSelector = createSelector(
  sdFeedbackSelector,
  data => data[SD_FEEDBACK_EVALUATION_STATS_OPEN_ENDED]
)

export const sdFeedbackEvaluationStatsSelector = createSelector(
  sdFeedbackSelector,
  data =>
    JSON.parse(JSON.stringify(data[SD_FEEDBACK_EVALUATION_STATS])) as {
      data: definitions['SDEvaluationStatsInChartDTO'][]
      loading: boolean
      error: AxiosError
    }
)
